import { Pipe, PipeTransform } from '@angular/core';

import { AssetFragment } from '../../common/generated-types';

@Pipe({
    name: 'focalPoint',
})
export class FocalPointPipe implements PipeTransform {
    transform(asset?: AssetFragment): string {
        if (asset?.focalPoint) {
            return `${asset.focalPoint.x * 100}% ${asset.focalPoint.y * 100}%`;
        }
        return 'center center';
    }
}
